import React from 'react';
import { StanModal } from '@/components';
import type { MFAConfig } from '@/lib/api/settings/types';
import { useDeleteMFA } from '../../../queries/useMFA';
import { stanNotify } from '@/lib/stanNotify';
import { handleApiError } from '@/lib/utils/apiErrorHandler';

interface DeleteMFAModalProps {
    isOpen: boolean;
    onClose: () => void;
    config: MFAConfig | null;
    onSuccess: () => void;
}

export const DeleteMFAModal: React.FC<DeleteMFAModalProps> = ({ isOpen, onClose, config, onSuccess }) => {
    const { mutate: deleteMFA, isPending } = useDeleteMFA();

    const handleDelete = () => {
        if (!config) return;

        deleteMFA(config.id, {
            onSuccess: () => {
                stanNotify({
                    type: 'success',
                    title: 'Success!',
                    text: 'Successfully deleted 2FA method!',
                });
                onSuccess();
                onClose();
            },
            onError: err => {
                handleApiError(err, 'Failed to delete 2FA method');
            },
        });
    };

    return (
        <StanModal
            id='delete-mfa-modal'
            isOpen={isOpen}
            title='Delete authentication method?'
            onClose={onClose}
            primaryActionLabel='Delete'
            primaryActionColor='destructive'
            primaryActionLoading={isPending}
            onPrimaryAction={handleDelete}
            secondaryActionLabel='Cancel'
            onSecondaryAction={onClose}
            size='sm'
            hideCloseButton
        >
            <p className='text-dark text-body-md text-center'>
                If you have a second authentication method, it will become your new default
            </p>
        </StanModal>
    );
};
